import { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'What is CreditGO?',
      answer: 'CreditGO is an AI-powered platform that evaluates business credit eligibility using advanced machine learning algorithms. We analyze financial data from the Central Registry of Macedonia (Централен Регистар на Македонија) processed by CompanyWall.mk to provide accurate credit predictions.',
    },
    {
      question: 'How accurate are the predictions?',
      answer: 'Our LSTM neural network model is trained on financial data from thousands of companies across Macedonia. While no prediction is 100% guaranteed, the system provides highly accurate assessments by analyzing historical trends, credit ratings, and multiple financial indicators.',
    },
    {
      question: 'What data is used for the analysis?',
      answer: 'CreditGO uses publicly available financial data from the Central Registry of Macedonia, including balance sheets, income statements, credit history, and other financial metrics. This data is processed and analyzed by CompanyWall.mk before being fed into the prediction model.',
    },
    {
      question: 'Is the company data secure?',
      answer: 'Yes, data security is a top priority. All data transmissions are encrypted, and only publicly available financial information is used. No sensitive personal information is stored beyond what is necessary for the eligibility check.',
    },
    {
      question: 'How long does the eligibility check take?',
      answer: 'The eligibility check is performed in real-time. Once a company registration number (EMBG/EMBS) is entered, the system retrieves and analyzes the relevant data within seconds, providing an instant prediction.',
    },
    {
      question: 'What factors affect credit eligibility?',
      answer: 'Several factors influence credit eligibility, including: historical financial performance, existing credit ratings, industry trends in Macedonia, debt-to-equity ratio, revenue patterns, and overall market conditions.',
    },
    {
      question: 'Can eligibility scores be improved?',
      answer: 'Yes! Improving financial health, maintaining a positive credit history, reducing outstanding debts, and demonstrating consistent revenue growth can all positively impact eligibility scores over time.',
    },
    {
      question: 'Is CreditGO a lending institution?',
      answer: 'No, CreditGO is not a bank or lending institution. It is a technology platform that helps businesses understand their credit eligibility before approaching financial institutions. CreditGO provides predictions and insights, not actual loans.',
    },
    {
      question: 'How much does it cost to use CreditGO?',
      answer: 'Basic eligibility checks are free. Every business should have access to understand their credit standing. Premium features with detailed analysis and recommendations may be available in the future.',
    },
    {
      question: 'Who can use CreditGO?',
      answer: 'Any registered business entity in Macedonia can use CreditGO. Whether it\'s a small startup, a growing SME, or an established corporation, the platform can help understand credit eligibility.',
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900" style={{ fontFamily: 'Georgia, serif' }}>
            Frequently Asked Questions
          </h2>
        </div>

        {/* FAQ Items */}
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex justify-between items-center text-left hover:bg-gray-100 transition-colors"
              >
                <span className="font-medium text-gray-900 pr-4">{faq.question}</span>
                <svg
                  className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
